import formName from 'constants/formName'
import { StateType, TierTwoFormErrorType, TierTwoFormType, TierTwoStepType } from 'data/types'
import isNil from 'lodash/isNil'
import { getFormSyncErrors, getFormValues as reduxGetFormValues } from 'redux-form'
import { createSelector } from 'reselect'

import app from '../../App/selectors'

const tierTwoDefaultValues = {
  loading: false,
  step: 'welcome'
}

// FIXME "as TierTwoFormType" should  not be needed as type should be infered, find out what's missing
const getFormValues = (state: StateType): TierTwoFormType =>
  reduxGetFormValues(formName.TIER_TWO)(state) as TierTwoFormType

const getValuesOrInitial = createSelector(getFormValues, (values: TierTwoFormType) => ({
  ...tierTwoDefaultValues,
  ...values
}))

// FIXME "as TierTwoFormType" should  not be needed as type should be infered, find out what's missing
const getErrors = (state: StateType): TierTwoFormErrorType =>
  getFormSyncErrors(formName.TIER_TWO)(state) as TierTwoFormErrorType

const getQuestionnaireValues = createSelector(getFormValues, (values: TierTwoFormType) => {
  if (isNil(values.expectedVolume) || isNil(values.intentions) || isNil(values.sourceOfFunds)) {
    return undefined
  }
  return {
    exchangePurpose: Object.keys(values.intentions),
    expectedVolume: values.expectedVolume,
    product: 'MERCURY',
    sourceOfFunds: values.sourceOfFunds
  }
})

const getStep: (state: StateType) => TierTwoStepType = createSelector(
  getValuesOrInitial,
  (form) => form.step
)

const isLoading: (state: StateType) => boolean = createSelector(
  getValuesOrInitial,
  app.getCountries,
  (form, countries) => form.loading || countries.length === 0
)

export default {
  getErrors,
  getQuestionnaireValues,
  getStep,
  getValuesOrInitial,
  isLoading
}
